const queryKeys = {
  advancePayCustomers: (productKey: string) => [
    "advancePayCustomers",
    productKey,
  ],
  advancePayPackages: (productKey: string) => [
    "advancePayPackages",
    productKey,
  ],
};

export default queryKeys;
